module.exports = __webpack_public_path__ + "img/blue_054.1e84f133.png";